import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByStatus',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const options = ['All', 'Not Acknowledged', 'Acknowledged', 'In Progress', 'Upload Complete'];
const selectedoption = ref('');

const resetCurrentPage = async () => {
  await store.dispatch('reports/resetCurrentPage');
};

const onSelect = async (selected: string) => {
  let query = { ...route.query, dataentrystatus: selected === 'All' ? '' : selected };
  if (selected !== null) {
    selectedoption.value = selected;
    await router.push({
      path: "dereports",
      query,
    });
    await resetCurrentPage();
  }
};

// Watcher for the route query parameter 'dataentrystatus'
watch(() => route.query.dataentrystatus, (newVal, oldVal) => {
  if (typeof newVal === 'string') {
    selectedoption.value = newVal;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_singleselect_text, {
      modelValue: selectedoption.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedoption).value = $event)),
      options: options,
      "allow-empty": true,
      taggable: false,
      onSelect: onSelect,
      placeholder: "Status"
    }, _createSlots({ _: 2 }, [
      (selectedoption.value)
        ? {
            name: "clear",
            fn: _withCtx(() => [
              _createElementVNode("i", {
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onSelect('')), ["prevent","stop"])),
                class: "multiselect__clear fa fa-times",
                "aria-label": "Clear"
              }, null, 32)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"])
  ]))
}
}

})